export const selectUser = ({ user }) => user;
